import { AlphaTag, AlphaTagPayload, Client, Hint, IMNO } from "../api";
import { ListCache } from "./ListCache";

const _cache = new ListCache<AlphaTag>();

export const hintToVal = (allMnos:IMNO[], hint?: Hint) => {
  return (t: AlphaTag) => {
    switch (hint) {
      case Hint.Abn:
        return t.clientABN;
      case Hint.Company:
        return t.clientName?.toLowerCase();
      case Hint.CreatedOn:
        return t.createdOn;
      case Hint.Name:
        return t.name?.toLowerCase();
      case Hint.MNO:
        return allMnos.filter(r => r.value == t.mnoId)[0]?.label?.toLowerCase();
    }
  };
};

export class AlphaTagStore {
  client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async getAlphaTags(
    abns: string[] | undefined,
    names: string[] | undefined,
    mnos: string[] | undefined,
    search: string | undefined,
    sorting: Hint,
    sortingDesc: boolean,
    pageNumber: number,
    pageSize: number,
    allMnos: IMNO[],
  ) {
    var res = await this.client.getAlphaTags(
      abns,
      names,
      mnos,
      search,
      sorting,
      sortingDesc,
      pageNumber,
      pageSize
    );

    return _cache
      .listContains(abns, (r) => r.clientABN)
      .listContains(names, (r) => r.name)
      .listContains(mnos, (r) => r.mnoId)
      .containsText(search, (r) => r.name)
      .mergeServerData(res, (r) => r.alphaTagId, pageSize, [
        hintToVal(allMnos, sorting),
        sortingDesc,
      ]);
  }

  async addAlphaTags(body: AlphaTagPayload | undefined) {
    var res = await this.client.addAlphaTags(body);

    for (var r of res) {
      if (r.alphaTagId) {
        _cache.set(r.alphaTagId, r);
      }
    }
  }

  async deleteAlphaTags(ids: string[] | undefined) {
    var res = await this.client.deleteAlphaTags(ids);

    for (var r of res) {
      _cache.del(r);
    }
  }
}
